// extracted by mini-css-extract-plugin
export default {"author":"EventPageContent_author__OHW0v","message":"EventPageContent_message__xKX5a","responses":"EventPageContent_responses__FcAzt","footer":"EventPageContent_footer__OhKQC"};